
var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.pdp = {
    VAR: {},
    init: function () {
        var _this = this;

        //add rollover to navigation

        let cur = null;

        document.querySelectorAll('.header__inline-menu details').forEach(details => {
            details.addEventListener('mouseover', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (cur !== this) {
                    this.setAttribute("open", true);
                    if (cur) cur.removeAttribute("open");
                    cur = this;
                }
            });
        });

        document.querySelector('.header__inline-menu').addEventListener('mouseleave', function (e) {
            e.preventDefault();
            if (cur) cur.removeAttribute("open");
            cur = null;
        });


        document.querySelectorAll('form[action="/cart/add"].pdp-form-class').forEach(function(form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                // check form is completed
                form.querySelector('.warning-text').textContent = "";
                var noComplete = false;

                form.querySelectorAll('.pdp-property').forEach(function (inp) {
                  if(inp.value == "")
                  {
                      noComplete = true;
                  }
                });

                if(noComplete)
                {
                    form.querySelector('.warning-text').textContent = "Please Select All Options";
                    return;
                }

                var addToCartBtn = form.querySelector('.addtocart');

                addToCartBtn.classList.add('disabled');
                addToCartBtn.disabled = true;
                PROJ.ajaxcart.opencart();
                document.getElementById('mini-cart').classList.add('loading');

                var formData = new FormData(form);

                fetch('/cart/add.js', {
                    method: 'POST',
                    body: new URLSearchParams(formData),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        PROJ.ajaxcart.updateCart();
                        addToCartBtn.classList.remove('disabled');
                        addToCartBtn.disabled = false;
                    })
                    .catch(error => {
                        PROJ.ajaxcart.updateCart();
                        console.error('Error adding item to cart:', error);
                    });
            });
        });




        // Function to update timeline visibility
        function updateTimeline(form, btnText) {
            var timelineElement = form.querySelector('.mto-timeline-text');
            if (timelineElement) {
                if (btnText === 'Made to Order') {
                    timelineElement.style.display = 'block';
                } else {
                    timelineElement.style.display = 'none';
                }
            }
        }

        // Shopify default option selector to change variables
        document.querySelectorAll('.pr-product-form .ops-default').forEach(function(item) {
            item.addEventListener('change', function(e) {
                e.preventDefault();

                this.closest('.pr-form').querySelectorAll('.ops-default').forEach(function(child) {
                    child.classList.remove('active');
                });
                this.classList.add('active');

                var formval = "";
                var thisForm = this.closest('.pdp-form-wrap');
                var allselected = true;
                thisForm.querySelectorAll('.ops-default').forEach(function(child) {
                    formval += child.value;
                    if(!child.value) allselected = false;
                });
                if(allselected)
                {
                    var thisopr = thisForm.querySelector('[data-options="'+formval+'"]');
                    var varid = thisopr.getAttribute('value');
                    var pricetag = thisopr.getAttribute('data-var-price');
                    var btnText = thisopr.getAttribute('data-btn-txt');
                    thisForm.querySelector('.pr-variants').value = varid;
                    thisForm.querySelector('.pdp-price-tag').innerHTML = pricetag;
                    var buttonSpan = thisForm.querySelector('.add-btn-set .addtocart span');
                    if (buttonSpan && btnText) {
                        buttonSpan.textContent = btnText;
                    }

                    // Show/hide timeline text based on button text
                    updateTimeline(thisForm, btnText);
                }

            });
        });



    },
    checkForm: function () {

    },
    updateCart: function () {
        location.reload();
    }
};

PROJ.ajaxcart = {
    VAR: {},

    init: function () {
        var _this = this;


        ['click', 'touchstart'].forEach(eventType => {
            document.body.addEventListener(eventType, function(e) {
                if (e.target.closest('a.mini_cart, .opencart, [href="/cart"]')) {
                   e.preventDefault();
                   e.stopPropagation();
                  _this.opencart();
                }
                if (e.target.closest('.closecart, .minicart-back')) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.closecart();
                }
            });
        });

        // quickpay toggle
        document.body.addEventListener('click', function (e) {
            if (e.target.closest('.quickpay-toggle')) {
                e.preventDefault();
                document.getElementById('mini-cart').classList.toggle('quickpay');
            }
        });

        //quickpay buttons
        if(document.querySelector('[wallet-configs]'))
        {
         var quickpay = JSON.parse(document.querySelector('[wallet-configs]').getAttribute('wallet-configs'));
        for (var s = 0; s < quickpay.length; s++) {
            document.getElementById('mini-cart').classList.add(quickpay[s].name);
        } }



        if (window.location.href.indexOf("minicart=true") > -1) {
            document.body.classList.add('mini-cart');
        }

        //remove from mini cart - Jqury

        document.body.addEventListener('click', function (e) {
            const target = e.target.closest('[data-directadd]');
            const remove = e.target.closest('.incart .remove');
            const gnote = e.target.closest('.giftnote-update');
            const gnoteopen = e.target.closest('.jl-opnenote');
            const jlgwCancel = e.target.closest('.jlgw-bottom .cancel');
            if (target) {
                e.preventDefault();
                _this.addItem(target.getAttribute('data-directadd'));
                PROJ.ajaxcart.opencart();
                document.getElementById('mini-cart').classList.add('loading');
            }else if(remove)
            {
                var par = remove.closest('.incart');
                var qty = 0;
                _this.updateItem(par.getAttribute('data-proid'), qty);
            }else if(jlgwCancel)
            {
                e.preventDefault();
                const note = document.getElementById('gift-note');
                note.value = null;
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attributes: {
                            'gift-note': note.value
                        }
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log("Cart updated:", data);
                        PROJ.ajaxcart.updateCart(); // Call updateCart after success
                    })
                    .catch(error => console.error("Error updating cart:", error));
            }else if(gnoteopen)
            {
                document.querySelector('.minicart-form')?.classList.toggle('opg-notes');
                document.getElementById('gift-note').focus();
            }else if(gnote)
            {
                const note = document.getElementById('gift-note');
                const notvalue = note.value?note.value:"true";
                if(gnote.classList.contains('cancel')) note.value = null;
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attributes: {
                            'gift-note': notvalue
                        }
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log("Cart updated:", data);
                        PROJ.ajaxcart.updateCart(); // Call updateCart after success
                    })
                    .catch(error => console.error("Error updating cart:", error));
            }
        });

    },addItem: function (id) {
        var _this = this;
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=1&id=${id}`,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                _this.updateCart();
            })
            .catch((error) => {
                _this.updateCart();
            });
    },
    opencart: function () {

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.add('mini-cart');
            setTimeout(function(){
                item.classList.add('mini-cart-ani');
            },500);
        });

    },
    closecart: function () {

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.remove('mini-cart');
            setTimeout(function(){
                item.classList.remove('mini-cart-ani');
            },500);
        });

    },
    updateCart: function () {
        var _this = this;
        document.querySelectorAll('body, html').forEach(item => {
            item.classList.remove('mini-cart-ani');
        });

        fetch("/cart?view=mini")
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                document.querySelector('#mini-cart .ajax_place').innerHTML = data;

            })
            .then(function () {
                _this.opencart();
                document.getElementById('mini-cart').classList.remove('loading');
                document.body.classList.add('mini-cart-ani');
                var quickpay = JSON.parse(document.querySelector('[wallet-configs]').getAttribute('wallet-configs'));
                for (var s = 0; s < quickpay.length; s++) {
                    document.getElementById('mini-cart').classList.add(quickpay[s].name);
                }
                var cartCountValue = document.querySelector('[data-cartcount]').getAttribute('data-cartcount');
                document.querySelectorAll('.cart-count').forEach(function (item) {
                    item.textContent = cartCountValue;
                });

            })
            .catch(function (error) {
                console.error('Error fetching cart:', error);
            });



    },

    updateItem: function (id, le) {
        var _this = this;
        document.getElementById('mini-cart').classList.add('loading');
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=${le}&id=${id}`,
        })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(() => {
                _this.updateCart();
            })
            .catch(() => {
                _this.updateCart();
            });
    }
};


document.addEventListener('DOMContentLoaded', function() {
        PROJ.pdp.init();
        PROJ.ajaxcart.init();

        // Initialize timeline text for all product forms
        document.querySelectorAll('form[action="/cart/add"].pdp-form-class').forEach(function(form) {
            var buttonSpan = form.querySelector('.add-btn-set .addtocart span');
            if (buttonSpan) {
                var btnText = buttonSpan.textContent.trim();
                var timelineElement = form.querySelector('.mto-timeline-text');
                if (timelineElement) {
                    if (btnText === 'Made to Order') {
                        timelineElement.style.display = 'block';
                    } else {
                        timelineElement.style.display = 'none';
                    }
                }
            }
        });
});

// cart giftwrap
/*
document.addEventListener('keyup', function (e) {
    if (e.target && e.target.id === 'gift-note') {
        var count = e.target.value.length;
        var max = e.target.getAttribute('maxlength');
        var nextElement = e.target.nextElementSibling;

        if (nextElement) {
            nextElement.innerHTML = "<strong>" + (max - count) + "</strong> Characters Remaining";
        }
    }
});
*/
